module.exports = __webpack_public_path__ + "img/09.dba09312.png";